<h3 mat-dialog-title>Send Email</h3>

<mat-dialog-content>
    <div class="row">
        <div class="col-sm-12">
            <send-email-popup></send-email-popup>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12" *ngIf="data != null">
            <label style="display: block;" for="emailTo">
                To
                <span matTooltip="Enter multple emails separated by a comma (',')"><i class="far fa-question-circle text-primary"></i></span>
            </label>
            <input type="text" id="emailTo" name="emailTo" class="form-control" [(ngModel)]="emailTo" />
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12" *ngIf="data!=null&&ccEmails.length==0">
            <label style="display: block;" for="emailCC">
                CC
                <span matTooltip="Enter multple emails separated by a comma (',')"><i class="far fa-question-circle text-primary"></i></span>
            </label>
            <input type="text" id="emailCC" name="emailCC" class="form-control" [(ngModel)]="emailCC" />
        </div>
        <div class="col-sm-12" *ngIf="data!=null&&ccEmails.length>0">
            <label style="display: block;" for="emailCC">
                CC
            </label>
            <kendo-multiselect [data]="ccEmails"
                               [textField]="'name'"
                               [valueField]="'email'"
                               [autoClose]="false"
                               [(ngModel)]="selectedCCEmails"
                               (valueChange)="ccEmailsChange($event)"
                               [popupSettings]="{ appendTo: 'component' }">
            </kendo-multiselect>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12" *ngIf="data != null && data.showSubject != null && data.showSubject">
            <label style="display: block;" for="emailSubject">Subject</label>
            <input type="text" id="emailSubject" name="emailSubject" class="form-control" [(ngModel)]="emailSubject" />
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12" *ngIf="data != null && data.showEmailBody != null && data.showEmailBody">
            <label style="display: block;" for="emailBody">Email Body</label>
            <textarea id="emailBody" name="emailBody" rows="5" cols="75" class="form-control" [(ngModel)]="emailBody"></textarea>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <button class="btn btn-primary m-2" (click)="select()">Send Email</button>
    <button class="btn btn-secondary m-2" (click)="cancel()">Cancel</button>
</mat-dialog-actions>
